// Web Configuration File
export const COMPANY_NAME = "Sivanandha Pipe Fittings Ltd";

export const API_BASE_URL3 = "https://rmpapi.iworkx.in"; // ✅ Live API
//export const API_BASE_URL = "http://192.168.1.36:9010"; // ✅ Local API
// export const API_BASE_URL = "http://localhost:63994"; // ✅ Local API (commented out)
//.export const API_BASE_URL2 = "http://192.168.1.51:2002";

// config.js
export const databaseKeys = [ "spflerp2O25", "erpsppipe","ERPIWXF2826CHN"];
